__turbopack_context__.v({
  "badge": "_8htmyG_badge",
  "dot": "_8htmyG_dot",
});
